angular.module('storefront.account')
    .component('vcAccountWishlist', {
        templateUrl: 'themes/assets/js/account/account-wishlist.tpl.liquid',
        require: {
            accountManager: '^vcAccountManager',
        },
        controller: ['$scope', 'listService', 'loadingIndicatorService', function ($scope, listService, loader) {
            const $ctrl = this;

            $ctrl.loader = loader;

            getWishlist();

            function getWishlist() {
                $ctrl.loader.isLoading = true;

                listService.getWishlist('wishlist', 'wishlist')
                    .then(function (response) {
                        $scope.items = response.data.items;
                        $ctrl.loader.isLoading = false;
                    });
            }

            $scope.deleteProductFromWishlist = function (product) {
                if (product) {
                    $ctrl.loader.isLoading = true;

                    listService.removeLineItem(product.id, 'wishlist', 'wishlist')
                        .then(function (response) {
                            $ctrl.loader.isLoading = false;
                            if (response.status === 200) {
                                getWishlist();
                            }
                        });
                }
            };
        }],
    });
